import { render, staticRenderFns } from "./mapDataTable.1.vue?vue&type=template&id=48fda8a3&scoped=true"
import script from "./mapDataTable.1.vue?vue&type=script&lang=js"
export * from "./mapDataTable.1.vue?vue&type=script&lang=js"
import style0 from "./mapDataTable.1.vue?vue&type=style&index=0&id=48fda8a3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fda8a3",
  null
  
)

export default component.exports